
import React, { useState } from 'react';
import OtpInput from 'react-otp-input';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router';
import { FormattedMessage } from 'react-intl';
import { setUserSession } from './AuthService';
import { severProperties} from './utility/Constants';const VerifyUser = (props) => {
    const [otp, setOtp] = useState(0);

    const [errorMessage, setErrorMessage] = useState('');

    const navigate = useNavigate();

    const handleChange = (code) => {
      setErrorMessage('');
      if(otp === 0 || otp.length === 0)
      {
        setErrorMessage(<div style={{color:'white',backgroundColor:'red'}}><FormattedMessage id="otpEmpty" /></div>);
      }
      else if(otp.length !== 6)
        {
          setErrorMessage(<div style={{color:'white',backgroundColor:'red'}}><FormattedMessage id="invalidOTP" /></div>);
        }
      else
      {
        let formData = new FormData();
        let status;
        formData.append('aplReferenceId', sessionStorage.getItem("user"));
        formData.append('authToken', sessionStorage.getItem("token"));
        formData.append('otp', otp);

        fetch([severProperties.serverURL,"/auth/verify-otp"].join(""), {
        method: "POST",
        headers: {
          'Access-Control-Allow-Origin': severProperties.serverCORS,
          'Access-Control-Allow-Methods': 'POST' // supported methods
        },
        body: formData,
        })
        .then((response) => { status = response.status; return response.text(); })
        .then((result) => {
          if (status=== 403 || status!== 200 || result === "") {
            setErrorMessage(<div style={{color:'white',backgroundColor:'red',padding:5,alignContent:'justify'}}><FormattedMessage id="otpdoesnotmatch" /></div>);
          }
          else if (status=== 500 || status=== 502) {
            setErrorMessage(<div style={{color:'white',backgroundColor:'red',padding:5,alignContent:'justify'}}>We're experiencing connectivity issues. Please check your network settings or try again later. If the problem persists, contact support for assistance.</div>);
          }
          else if (status=== 412) {
            setErrorMessage(<div style={{color:'white',backgroundColor:'red',padding:5,alignContent:'justify'}}><FormattedMessage id="InvalidAuthSessionToken" /></div>);
          } else {
            setUserSession(sessionStorage.getItem("token"), result, sessionStorage.getItem("user"));
            navigate("/certificate");
          }
        })
        .catch((error)=>{
          setErrorMessage(<div style={{color:'white',backgroundColor:'red',padding:5,alignContent:'justify'}}>We're experiencing connectivity issues. Please check your network settings or try again later. If the problem persists, contact support for assistance.</div>); 
        });
        
      }
    }
    
    
    return (
  <div style={{paddingTop:'10vh'}}> 
      <OtpInput
      value={otp}
      onChange={setOtp}
      numInputs={6}
      renderSeparator={<span> - </span>}
        isInputNum={true}
        shouldAutoFocus={true}
      renderInput={(props) => <input {...props} />}
      inputStyle={{
        borderRadius: "8px",
        width: "54px",
        height: "54px",
        fontSize: "18px",
        color: "#000",
        fontWeight: "400",
        caretColor: "blue",
        border: "1px solid #CFD3DB",
      }}
      focusStyle={{
        border: "1px solid #CFD3DB",
        outline: "none"
      }}          

    /> 
    <p/>
    {errorMessage &&
              <center><h6 className="error" style={{color:'red'}}> {errorMessage} </h6></center>}
    <Button variant="contained" className="gfg-button" onClick={handleChange} style={{marginTop:30,width:'100%'}}>{<FormattedMessage id="verifyOTP" />}</Button>
    </div>
    )
}

export default VerifyUser